<template>
  <div class="" :class="FormDataType.FieldSize">
    <b-form-group
      :class="title_position"
      :label-cols-lg="labels_lg"
      id="example text"
      :label="FormDataType.FieldTitle"
      label-for="text" 
    >
      <b-form-input
        :class="[clas, { 'is-invalid': v.$error }]"
        v-model="InputName"
        :min="FormDataType.min"
        :max="FormDataType.max"
        :step="FormDataType.step"
        :type="FormDataType.FieldType"
        @input="$emit('input', InputName)"
        for="text"
        :disabled="FormDataType.Disabled"
      ></b-form-input>

      <template v-if="v.$error">
        <div v-for="(error, index) of v.$silentErrors" :key="index"> 
          <div > 
           <span v-if="error.$validator == 'required'">{{  $t("ValidationMessage.required") }}</span>
           <span v-else-if="error.$validator == 'numeric'">{{  $t("ValidationMessage.numeric") }}</span>
           <span v-else-if="error.$validator == 'email'">{{  $t("ValidationMessage.email") }}</span>
           <span v-else-if="error.$validator == 'minLength'">İstenilen uzunluk sağlanamadı</span>
             <span v-else>{{ error.$message}}</span>
         </div>
        </div>
      </template>
    </b-form-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      InputName: "",
    };
  },

  props: {
    v: {
      type: Object,
    },
    FormDataType: {},
    FormPost: String,
    clas: String,
    Value: null,
    min: String,
    step: String,
    max: String,
    title_position: String,
    labels_lg: Number,
  },
  watch: {
    FormPost() {
      this.$v.$touch();
    },
    Value() {
      this.InputName = this.Value;
    },
  },
  created: function () {
    this.InputName = this.Value;
  },
};
</script>
